import { InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { Drawer } from "antd";
import React, { useEffect, useState } from "react";
import LineChart from "./LineChart";
import { getFeedFilter } from "../redux/selectors/feed-filter.selectors";
import { useSelector } from "react-redux";
import { getMainProduct, getProduct, getReferencesFilter, getThread } from "../redux/selectors";
import { summaryService } from "../api";
import Coverage from "./Coverage";

const Metrics: React.FC = () => {
  const [open, setOpen] = useState(false);
  const feedFilter = useSelector(getFeedFilter);
  const [loading, setLoading] = useState(true);
  const thread = useSelector(getThread);
  const product = useSelector(getProduct);
  const mainProduct = useSelector(getMainProduct);
  const start = new Date();
  start.setDate(start.getDate() - 29);
  const [graphData, setGraphData] = useState([]);
  const [sumCount, setSumCount] = useState(0);
  const referencesFilter = useSelector(getReferencesFilter);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };
  const options = [
    { label: " Другое", value: "period" },
    { label: "Сегодня", value: "today" },
    { label: "7д", value: "week" },
    { label: "1м", value: "month" },
  ];

  useEffect(() => {
    setLoading(true);
    if (thread && mainProduct && product) {
      let params = {
        thread_id: +thread.id,
        product_id: window.location.pathname.includes("main")
          ? mainProduct?.id
          : product,
        from: feedFilter.from.slice(0, 10) + " 00:00:00",
        to: feedFilter.to.slice(0, 10) + " 23:59:59",
        //referenceFilter: referencesFilter,
      };

      summaryService
        .loadStats(params)
        .then((resp) => {
          setGraphData(resp.graph_data);
          let sum = 0;
          resp.graph_data.forEach(function (num: any) {
            sum += num[1];
          });
          setSumCount(sum);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [thread, feedFilter, product, referencesFilter, mainProduct]);

  return (
    <div className="grid1-2">
      <Coverage title={"attendance"} />
      <div className="white-block-small">
        <div className="flex-space">
          <p className="block-title">
            Вовлеченность
            <InfoCircleOutlined className="info" onClick={showDrawer} />
          </p>
        </div>
        {loading ? (
          <div className="feed-posts-loader">
            <LoadingOutlined />
          </div>
        ) : (
          <>
            <div className="title-big  margin-bottom">
              {(+sumCount)?.toLocaleString()}
            </div>
            <LineChart graphData={graphData} />
          </>
        )}
      </div>
      <Drawer title="Что отображает этот график?" onClose={onClose} open={open}>
        <p className="purple-border">
          График иллюстрирует общую сумму комментариев, лайков (реакций) и
          репостов сообщений за выбранный период.
        </p>
        <p className="title-small">Как интерпретировать данные</p>
        <ol>
          <li>
            Временные интервалы: Вы можете выбрать различные временные интервалы
            для анализа динамики упоминаний.
          </li>
        </ol>
        <p className="title-small">Источники данных</p>
        <ul>
          <li>Telegram</li>
          <li>Вконтакте</li>
          <li>Одноклассники</li>
          <li>Youtube</li>
          <li>Дзен</li>
        </ul>
        <p className="gray-block">
          <p className="gray-title">ПРИМЕЧАНИЕ</p>Данные обновляются в реальном
          времени, что позволяет вам следить за актуальными трендами и реакцией
          аудитории на ваш контент
        </p>
      </Drawer>
    </div>
  );
};

export default Metrics;
